import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { projects } from "../../data/projects";
import { ErrorPage } from "./Error";



export const PersonalProjects = () => {
  const navigation = useNavigate();
  let { id } = useParams();
  const [checkPath, setCheckPath] = useState<boolean>(true);


  useEffect(() => {
    if (!id) {
      navigation(`/projects/1`);
    } else if (id) {
      setCheckPath(projects.some((project) => project.id === +id!));
    }
  }, [checkPath, id, navigation]);

  if (!checkPath) {
    return <ErrorPage />;
  }

  return (
    <>
      <section
        id="about"
        className={`bg-white-100 dark:bg-gray-800 ${window.innerWidth > 767 ? "bg-corner" : ""}`}
      >
        <div className="container mx-auto px-10 py-20 items-center flex flex-col md:flex-row ">
          <div
            id="carousel"
            className="image-shadow-lighter dark:image-shadow carousel relative w-full"
            data-bs-interval="false"
          >
            <div className="carousel-inner relative w-full overflow-hidden">
              {projects.map((project, index) => (
                <div
                  id={project.id.toLocaleString()}
                  key={project.id.toLocaleString()}
                  className={`carousel-item ${
                    id && +id === index + 1 ? "active" : ""
                  } relative float-left w-full h-44 md:h-150 `}
                >
                  <img
                    src={require(`../../${project.image}`)}
                    className="block absolute inset-0 w-full h-full object-cover object-top "
                    alt="Wild Landscape"
                  />
                </div>
              ))}
            </div>
            <button
              onClick={() => {
                if (id) {
                  id === "1"
                    ? navigation(`/projects/${projects.length}`)
                    : navigation(`/projects/${parseInt(id) - 1}`);
                }
              }}
              className="carousel-control-prev absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0"
              type="button"
              data-bs-target="#carousel"
              data-bs-slide="prev"
            >
              <i className="fa-solid fa-2x text-black fa-chevron-left"></i>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              onClick={() => {
                if (id) {
                  id === projects.length.toLocaleString()
                    ? navigation(`/projects/1`)
                    : navigation(`/projects/${parseInt(id) + 1}`);
                }
              }}
              className="carousel-control-next absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0"
              type="button"
              data-bs-target="#carousel"
              data-bs-slide="next"
            >
              <i className="fa-solid fa-2x text-black fa-chevron-right"></i>
              <span className="visually-hidden">Next</span>
            </button>
          </div>

          {checkPath && id && +id <= projects.length && (
            <div className="w-full md:w-1/2 md:ml-20 mt-20 md:mt-0">
              <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                {projects[+id - 1].title}
              </h2>
              <p className="title-font text-lg font-medium text-gray-700 dark:text-white mb-3">
                {projects[+id - 1].subtitle}
              </p>
              <p className="leading-relaxed text-gray-700 dark:text-white">
                {projects[+id - 1].fullDesc}
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
};
